<template>
  <router-link
    :to="{ name: 'bootcamp', params: { id: bootcamp.id } }"
    class="instructor-tile"
  >
    <div class="instructors-tile__instructor-wrapper">
      <img
        class="instructors-tile__picture"
        :src="getInstructorImg(instructor)"
      />
      <div class="instructors-tile__instructor-details">
        <div class="instructors-tile__name">
          {{ getInstructorName(instructor) }}
        </div>
        <div class="instructors-tile__certificates-wrapper">
          <template v-if="instructor.certifications.length">
            <div
              class="instructors-tile__certificate"
              v-for="(cert, i) in instructor.certifications"
              :key="cert.id"
            >
              {{ cert.name }}
              <span
                v-if="isCommaShown(instructor.certifications.length, i)"
                class="instructors-tile__certificate--comma"
                >,</span
              >
            </div>
          </template>
          <div v-else class="instructors-tile__certificate">
            INE {{ learningAreaName }} Instructor
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'instructorTile',
  props: {
    instructor: {
      type: Object,
      required: true,
    },
    bootcamp: {
      type: Object,
      required: true,
    },
    height: {
      type: [String, Number],
      required: false,
      default: () => 276,
    },
    isResumeSnipeShown: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    learningAreaName: {
      type: String,
      required: true,
    },
  },
  setup() {
    const maxLength = ref(80)
    const tileSizes = ref({
      small: 286,
      medium: 386,
      large: 490,
    })
    const getInstructorImg = instructor => {
      return (
        instructor.profile_img_url ||
        require('@/assets/images/instructor_fallback.png')
      )
    }

    const getInstructorName = instructor => {
      return instructor.name ? instructor.name : 'INE Instructor'
    }

    const isCommaShown = (arrLength, index) => {
      return arrLength > 1 && arrLength !== index + 1
    }
    return {
      maxLength,
      tileSizes,
      getInstructorImg,
      getInstructorName,
      isCommaShown,
    }
  },
})
</script>

<style lang="scss">
.instructors-tile {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  transition: all 0.2s ease-out;
  width: auto;
  &-carousel {
    &__swiper {
      height: 318px;
      width: 450px;
      width: auto;
    }
  }
  &__instructor {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &__dot-wrapper {
    display: flex;
    justify-content: center;
  }
  &__dot {
    display: block;
    width: 10px;
    height: 10px;
    background-color: #ffffff;
    border-radius: 50%;
    margin: 2px 5px;
    cursor: pointer;
    opacity: 0.2;
    &.active {
      opacity: 1;
      border: none;
      background: #ffffff;
    }
  }
  &__arrows-wrapper {
    position: absolute;
    display: flex;
    justify-content: space-between;
    top: 106px;
    transform: translateY(-50%);
    width: 288px;
    z-index: 20;
  }
  &__arrow {
    display: block;
    cursor: pointer;
  }
  &__instructor-wrapper {
    position: relative;
    position: relative;
    flex-direction: column;
    display: flex;
    align-items: center;
  }
  &__instructor-details {
    text-align: center;
    z-index: 10;
    margin: 20px 0 30px;
    max-width: 455px;
    color: var(--white);
    @include mobile {
      margin: 20px 0;
    }
  }
  &__picture {
    max-height: 116px;
    max-width: 116px;
    height: 116px;
    width: 116px;
    border-radius: 50%;
    @include mobile {
      max-height: 212px;
      max-width: 212px;
      height: 212px;
      width: 212px;
    }
  }
  &__name {
    font-family: var(--font-bold);
    font-size: rem(16px);
    line-height: 23px;
    margin-bottom: 5px;
    @include mobile {
      font-size: rem(16px);
    }
  }
  &__certificates-wrapper {
    font-size: rem(12px);
    line-height: 14px;
  }
  &__certificate {
    color: var(--athens-gray);
    display: inline-block;
    &--comma {
      margin-right: 2px;
    }
  }
}
.instructor-tile {
  &.swiper-slide {
    opacity: 0;
    transition: opacity 0.2s ease-out;
  }
  &.swiper-slide-active {
    opacity: 1;
    transition: opacity 0.2s ease-out;
  }
}
</style>
